export const cssAbbr = {
  fg: 'flex-grow',
  fd: 'flex-direction',
  jc: 'justify-content',
  d: 'display',
  pos: 'position',
  z: 'z-index',
  ff: 'font-family',
  fs: 'font-size',
  fw: 'font-weight',
  fst: 'font-style',
  td: 'text-decoration',
  ta: 'text-align',
  ti: 'text-indent',
  b: 'border',
  br: 'border-radius',
  p: 'padding',
  m: 'margin',
  mw: 'max-width',
  mh: 'max-height',
  miw: 'min-width',
  mih: 'min-height',
  ov: 'overflow',
  ovx: 'overflow-x',
  ovy: 'overflow-y',
  bk: 'background',
};

export const kvCb = (key, val) => {
  key = key?.trim(); val = val?.trim();
  key = cssAbbr[key] || key;
  if (key === 'border' && !val.match(' ')) val = '1px solid ' + val;
  return [key, val];
};

export const strStyle = (str, tgt = {}, cb) => {
  if (typeof str !== 'string') return str;
  str.split(';').forEach(y => {
    let [key, val] = y.split(':');
    if (!key || !val) return;
    [key, val] = kvCb(key, val);
    if (cb) cb(key, val, tgt);
    else tgt[key] = val;
  });
  return tgt;
};

export const styleCb = (el, txt, state) => {
  const rx = /([-_a-zA-Z0-9]+)\s*:\s*([^(]+(?=\))|.+?(?=;))/g;
  const x = txt ?? el.children[0];
  const x2 = x.replace(rx, (_, key, val) => {
    [key, val] = kvCb(key, val);
    return key + ': ' + val;
  });
  if (el.children) el.children[0] = x2;
  return x2;
};
